module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corona_australis/cra_border-6dd337f2123af742f2dcbf28401f91c8.gif";